module.exports = __webpack_public_path__ + "static/055_Gippsland-98dbc69edcae0da9e097b528f0b77c93.jpg";